import { nzApiAxios } from 'src/utils/nz-axios/nz-axios';
import { BusinessMapLocationItem, BusinessMapParams, MapCategory, ProposeLocationWithCaptcha } from '../types';

const locationPropositionsApiUrl = '/BusinessMapLocationPropositions';
export const mapApiUrl = '/BusinessMap';

const ApiUrls = {
  mapApiUrl,
  locationPropositionsApiUrl
};

const PostMapLocationPropositionRequest = (data: ProposeLocationWithCaptcha): Promise<void> =>
  nzApiAxios.post(locationPropositionsApiUrl, data);

const GetBusinessMap = (data: BusinessMapParams): Promise<BusinessMapLocationItem[]> =>
  nzApiAxios.get(mapApiUrl, { params: data }).then((response) => response.data);

const GetRegions = (): Promise<[]> => nzApiAxios.get(mapApiUrl + '/regions').then((response) => response.data);

const GetCategories = (): Promise<MapCategory[]> =>
  nzApiAxios.get(mapApiUrl + '/categories').then((response) => response.data);

const API = {
  proposeMapLocation: PostMapLocationPropositionRequest,
  getBusinessMap: GetBusinessMap,
  getRegions: GetRegions,
  getCategories: GetCategories
};

export { ApiUrls };
export default API;
